"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _borderRadius = require("../../../styles/borderRadius");

var _colors = require("../../../styles/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    background-color: transparent;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    outline: none;\n    border-radius: ", ";\n    transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n    &:focus,\n    &:active {\n        outline: 0;\n        box-shadow: 0 0 0 4px ", ";\n    }\n\n    &:active {\n        transform: scale(0.97);\n        transition: all 0.2s ease;\n    }\n\n    &:hover {\n        box-shadow: 0 0 0 4px ", ";\n        transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButton = _styledComponents["default"].button(_templateObject(), _borderRadius.BORDER_RADIUS_2, _colors.COLOR_GRAY_2, _colors.COLOR_GRAY_2);

var _default = StyledButton;
exports["default"] = _default;